import type {ShapeType} from "@repo/shared";

import {useGameState} from "~/contexts/gamestate/useGameState";
import {ManagedInstancing} from "~/three/instanced-rendering/ManagedInstancing";

import {useSelection} from "../selection/useSelection";

const GameObjects = () => {
  const {getFullInstanceTypes} = useGameState();
  const {handleSelectClick} = useSelection();

  return (
    <>
      {getFullInstanceTypes().map(
        ([shapeType, {manager, material, geometry}], index) => (
          <ManagedInstancing
            key={index}
            instanceManager={manager}
            onClick={(event) =>
              handleSelectClick(event, shapeType as unknown as ShapeType)
            }
          >
            {material}
            {geometry}
          </ManagedInstancing>
        ),
      )}
    </>
  );
};

export default GameObjects;
